var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "order_history_list" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c(
                  "section",
                  [
                    _c("h2", [_vm._v("ご注文履歴")]),
                    _vm._v(" "),
                    _vm._l(_vm.productList, function(order, index) {
                      return _c(
                        "div",
                        {
                          key: "history-" + index,
                          staticClass: "history_list"
                        },
                        [
                          _c("dd-history", {
                            attrs: { orderData: order },
                            on: { detail: _vm.detail }
                          })
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("dd-pager", {
                      attrs: {
                        pageNo: _vm.pageNo,
                        dataCountPerPage: 15,
                        totalDataCount: _vm.orderHistoryList.length
                      },
                      on: { paging: _vm.paging }
                    }),
                    _vm._v(" "),
                    _vm.productList.length <= 0
                      ? _c("div", { staticClass: "not_history" }, [
                          _vm._v("ご注文履歴がありません。")
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e0a333c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0a333c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcOrderHistoryList.vue
// module id = null
// module chunks = 